export enum OrderStatusEnums {
  Complete = "Complete",
  Cancelled = "Cancelled",
}

export enum StockroomCategoryNameEnums {
  Chemicals = "Chemicals",
}
